import { LinksGroup } from 'app/area/links-section/types-store';

export const ACTION = {
  REQUEST_LINKS: 'LINKS_SECTION:REQUEST_LINKS',
  RECEIVE_LINKS: 'LINKS_SECTION:RECEIVE_LINKS',
  FAIL_LINKS: 'LINKS_SECTION:FAIL_LINKS'
};

export class RequestLinks {
  public type: string = ACTION.REQUEST_LINKS;
}

export class ReceiveLinks {
  public type: string = ACTION.RECEIVE_LINKS;
  constructor(public linksGroups: LinksGroup[]) {}
}

export class FailedLinks {
  public type: string = ACTION.FAIL_LINKS;
}
